import { render, staticRenderFns } from "./Bets.vue?vue&type=template&id=acbbf460&scoped=true&"
import script from "./Bets.vue?vue&type=script&lang=js&"
export * from "./Bets.vue?vue&type=script&lang=js&"
import style0 from "./Bets.vue?vue&type=style&index=0&id=acbbf460&prod&scoped=true&lang=css&"
import style1 from "./Bets.vue?vue&type=style&index=1&id=acbbf460&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbbf460",
  null
  
)

export default component.exports